/**************************************
 ** AtlasViewerConfiguration
 *
 *  Contains configuration information for the viewer.
 ***************************************/
define('atlas/AtlasViewerConfiguration', ['atlas/AtlasConstants'], function(Constants) {
    'use strict';

    var AtlasViewerConfiguration = function(viewerId, controlId, dragId, hideCursor) {
        this._viewerId = viewerId;
        this._controlId = controlId;
        this._dragId = dragId;
        this._hideCursor = hideCursor;

        //behaviors
        this._thresholdType = Constants.THRESHOLD_ADAPTIVE;
        this._staticThreshold = 50;
        this._adaptiveThreshold = 0.85;

        //sphere info
        this._initialImageIndex = 'G05';
    };

    return AtlasViewerConfiguration;
});
